// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host{display:block}.condition{display:grid;align-items:center;grid-auto-columns:1fr;grid-template-columns:min-content 1fr;grid-template-rows:min-content;gap:10px;grid-template-areas:"integration-icon sentence"}.condition__icon{grid-area:integration-icon}.condition__sentence{grid-area:sentence}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
